import { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps, DataTableRow } from 'components/dataTable/dataTable.types';

import { PAYOUT_COLUMNS_IDS } from '../../keys';
import { AccountOrWalletNumberCell } from './accountCell';
import { ActionCell } from './actionCell';
import { DefaultCell } from './defaultCell';
import { PaymentRailCell } from './formattedCell';
import { PaymentTypeCell } from './paymentTypeCell';
import { IsMainCell } from './tagCell';
import { UppercaseCell } from './uppercaseCell';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [PAYOUT_COLUMNS_IDS.TYPE]: PaymentTypeCell,
  [PAYOUT_COLUMNS_IDS.CURRENCY]: UppercaseCell,
  [PAYOUT_COLUMNS_IDS.ACCOUNT_OR_WALLET_NUMBER]: AccountOrWalletNumberCell,
  [PAYOUT_COLUMNS_IDS.PAYMENT_RAIL]: PaymentRailCell,
  [PAYOUT_COLUMNS_IDS.IS_MAIN]: IsMainCell,
  [PAYOUT_COLUMNS_IDS.ACTIONS]: ActionCell,

  default: DefaultCell,
};

export const BankAccountCellWithProps = (editPayout: (row: DataTableRow) => void, isDirectFlow: boolean) => (props: DataTableCellProps) => {
  return BankAccountCell({ ...props, passedProps: { editPayout: () => editPayout(props.row), isDirectFlow } });
};

export const BankAccountCell: FunctionComponent<DataTableCellProps> = (props) => {
  const { column } = props;

  const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

  return <SelectedComponent {...props} />;
};
